export const leadTimeUnitList = ['CALENDAR_DAYS', 'WORKING_DAYS'] as const;

export type LeadTimeUnit = (typeof leadTimeUnitList)[number];

export const leadTimeEnforcementList = ['BLOCK', 'WARN'] as const;

export type LeadTimeEnforcement = (typeof leadTimeEnforcementList)[number];

export const travelEnforcementList = leadTimeEnforcementList;

export type TravelEnforcement = LeadTimeEnforcement;

export const travelReturnModeList = ['FULL_RERUN', 'STRAIGHT_BACK'] as const;

export type TravelReturnMode = (typeof travelReturnModeList)[number];

export interface TravelSettings {
  id: number;
  daysBeforeDeparture: number;
  leadTimeUnit: LeadTimeUnit;
  erasmusDaysBeforeDeparture: number;
  erasmusLeadTimeUnit: LeadTimeUnit;
  leadTimeEnforcement: LeadTimeEnforcement;
  parallelEnforcement: TravelEnforcement;
  erasmusParallelEnforcement: TravelEnforcement;
  leaveDaysEnforcement: TravelEnforcement;
  dayCapEnforcement: TravelEnforcement;
  returnMode: TravelReturnMode;
  reminderIntervalDays: number;
  researchSecretariatVerification: boolean;
  internationalSecretariatVerification: boolean;
  version: number;
}

export interface TravelSettingsRequest {
  daysBeforeDeparture: number;
  leadTimeUnit: LeadTimeUnit;
  erasmusDaysBeforeDeparture: number;
  erasmusLeadTimeUnit: LeadTimeUnit;
  leadTimeEnforcement: LeadTimeEnforcement;
  parallelEnforcement: TravelEnforcement;
  erasmusParallelEnforcement: TravelEnforcement;
  leaveDaysEnforcement: TravelEnforcement;
  dayCapEnforcement: TravelEnforcement;
  returnMode: TravelReturnMode;
  reminderIntervalDays: number;
  researchSecretariatVerification: boolean;
  internationalSecretariatVerification: boolean;
  version: number;
}
